import React, { useEffect, useState } from 'react';
import classnames from 'clsx';
import './style.scss';

type SegmentedControlsProps = {
  options: Array<{
    label: string;
    value: string;
  }>;
  className?: string;
  selected?: string;
  onChange?: (key: string) => void;
  disabled?: boolean;
  uniqueKey?: string;
  childClassName?: string;
};

export const SegmentedControls: React.FC<SegmentedControlsProps> = ({
  options,
  onChange,
  selected,
  disabled,
  className,
  childClassName,
  uniqueKey,
}) => {
  const [active, setActive] = useState<string>('');

  // Handle button click
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (!disabled) {
      const value: string = e.target.value;

      setActive(value);

      // If onSelect is supplied call the onChange, pass key of the button.
      if (typeof onChange === 'function') {
        onChange(value);
      }
    }
  };

  useEffect(() => {
    if (selected) {
      setActive(selected);
    }
  }, [selected]);

  return (
    <ul className={classnames({ disabled }, 'c-segmented-control flex flex-1 m-0', className)}>
      {options.map((item, idx) => {
        return (
          <li
            key={idx}
            className={classnames('c-segmented-control__item flex-grow whitespace-normal block', childClassName)}
          >
            <input
              className="c-segmented-control__input"
              type="radio"
              value={item.value}
              name="option"
              id={'option-' + idx + uniqueKey}
              checked={active === item.value}
              onChange={handleChange}
            />
            <label className="c-segmented-control__label" htmlFor={'option-' + idx + uniqueKey}>
              {item.label}
            </label>
          </li>
        );
      })}
    </ul>
  );
};
